import { useTranslation } from 'react-i18next';
import { Grid } from '@shared/ui';

import { SectionHeader } from './SectionHeader';
import { ConfirmDialogShowcase } from './overlay/ConfirmDialogShowcase';
import { DialogShowcase } from './overlay/DialogShowcase';
import { DropdownMenuShowcase } from './overlay/DropdownMenuShowcase';
import { ImagePreviewDialogShowcase } from './overlay/ImagePreviewDialogShowcase';
import { PopoverShowcase } from './overlay/PopoverShowcase';
import { SheetShowcase } from './overlay/SheetShowcase';
import { TooltipShowcase } from './overlay/TooltipShowcase';

export function OverlaySection() {
  const { t } = useTranslation();

  return (
    <section id="overlay" className="space-y-6">
      <SectionHeader
        title={t('uiLibrary.overlay.title')}
        description={t('uiLibrary.overlay.description')}
      />

      <Grid cols={1} gap="lg" className="lg:grid-cols-2">
        <DialogShowcase />
        <ImagePreviewDialogShowcase />
        <ConfirmDialogShowcase />
        <SheetShowcase />
        <PopoverShowcase />
        <TooltipShowcase />
        <div className="lg:col-span-2">
          <DropdownMenuShowcase />
        </div>
      </Grid>
    </section>
  );
}
